import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from 'synto-common';
import {ECaseSearchBarComponent} from './search-bar.component';

@NgModule({
    declarations: [
        ECaseSearchBarComponent
    ],
    imports     : [
        SharedModule,
        RouterModule
    ],
    exports     : [
        ECaseSearchBarComponent
    ]
})
export class ECaseSearchBarModule
{
}
